export abstract class AuthorizationProvider {
    public abstract hasPermission(permission: string): Promise<boolean>;
}